// The whole question bank, in one place.
//
// SHIPPED WITH THE APP, not fetched. The brief asks for something that works
// on a phone with patchy signal, and a trivia API cannot supply the shapes
// these modes need anyway: ordered lists for Sort It, comparable numeric
// values for Higher or Lower, four-item sets with a stated reason for Odd One
// Out. Every question here is hand-authored against that requirement.
//
// Each entry is stamped with its `mode` on the way out, so nothing downstream
// has to remember which file a question came from.

import lastGasp from './lastGasp.js';
import higherLower from './higherLower.js';
import oddOneOut from './oddOneOut.js';
import sortIt from './sortIt.js';
import guessTheThing from './guessTheThing.js';
import chainReaction from './chainReaction.js';

const stamp = (mode, rows) => rows.map((q) => ({ ...q, mode }));

export const BANK = {
  'last-gasp': stamp('last-gasp', lastGasp),
  'higher-lower': stamp('higher-lower', higherLower),
  'odd-one-out': stamp('odd-one-out', oddOneOut),
  'sort-it': stamp('sort-it', sortIt),
  'guess-the-thing': stamp('guess-the-thing', guessTheThing),
  'chain-reaction': stamp('chain-reaction', chainReaction),
};

/** Every question in every mode. */
export const ALL_QUESTIONS = Object.values(BANK).flat();

/** How many questions the app ships with — shown on the About screen. */
export const BANK_SIZE = ALL_QUESTIONS.length;

/** How many are in one mode. Used by the mode picker to show depth. */
export const bankSize = (mode) => BANK[mode]?.length ?? 0;
